/** @format */

import { buildPdfContentTree, groupsToItems } from "../features/pdfExport/buildPdfContentTree";
import { groupByQuestion } from "../features/pdfExport/layout";
import { QuestionSheet } from "../features/pdfExport/preview/QuestionSheet";
import { useBrand } from "../hooks/useBrand";
import type { PaperGroup } from "../hooks/usePaperQuestions";
import { resolveActiveLang } from "../utils/helpers";
import { useTranslation } from "react-i18next";

interface PdfViewProps {
	groups: PaperGroup[];
}

/**
 * On-screen twin of the exported questions paper.
 * Builds the same content tree as the export trigger (PaperActions) and renders one A4 sheet per question group
 * so the preview and PDF cannot drift.
 */
export const PDFView = ({ groups }: PdfViewProps) => {
	const { brand } = useBrand();
	const { i18n } = useTranslation();
	const activeLang = resolveActiveLang(i18n.language);
	const { questions, answerLines } = buildPdfContentTree(groupsToItems(groups, activeLang), "", activeLang);

	return (
		<div className="flex flex-col gap-5 pb-5" data-testid="generated-paper-content">
			{groupByQuestion(questions).map((group, groupIndex) => (
				<QuestionSheet
					key={`${group[0].groupId}-${groupIndex}`}
					group={group}
					groupIndex={groupIndex}
					brand={brand}
					answerLines={answerLines}
				/>
			))}
		</div>
	);
};
